import React, { useEffect } from "react";
import { useUnit } from "effector-react";
import logoSuperDucha from "../../../../assets/images/logo-super-ducha-white.png";
import {
  restartInteraction,
  VacuumStore,
} from "../../../../stores/VacuumStore/VacuumStore";
import { TextContainer } from "./FailedPaymentStyles";
import {
  GradientContainer,
  LogoSuperDucha,
  LogoWrapper,
  Subtitle,
} from "../../TotemVacuumStyles";

const FailedPayment: React.FC = () => {
  const { errorMsg } = useUnit(VacuumStore);

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleRestart();
    }, 7500);

    return () => clearTimeout(timeout);
  }, []);

  const handleRestart = () => {
    restartInteraction();
  };

  const msg = errorMsg?.length ? errorMsg : "Pagamento não efetuado";

  return (
    <GradientContainer onClick={handleRestart}>
      <LogoWrapper>
        <LogoSuperDucha src={logoSuperDucha} alt="Super Ducha" />
      </LogoWrapper>
      <TextContainer>
        <Subtitle fontSize={"2.25rem"}>{msg}</Subtitle>
      </TextContainer>
    </GradientContainer>
  );
};

export default FailedPayment;
